import React from 'react';
import { Container, Card, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEOHead from '../components/SEO/SEOHead';
import { GUIDE_ARTICLES, getGuideSlug } from '../guides/registry';

const GuidesIndexPage = () => {
  const { t, i18n } = useTranslation('guides');
  const lang = i18n.language?.startsWith('en') ? 'en' : 'fr';

  return (
    <>
      <SEOHead
        title={t('index.meta.title')}
        description={t('index.meta.description')}
        keywords={t('index.meta.keywords')}
        canonical="https://assistance.leagora.io/guides"
      />

      <Container className="py-5" style={{ maxWidth: '960px' }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="h2 fw-bold mb-0">{t('index.h1')}</h1>
          <Button as={Link} to="/" variant="outline-primary" size="sm">
            {t('common.backHome')}
          </Button>
        </div>

        <p className="lead text-secondary mb-5">{t('index.intro')}</p>

        <Row xs={1} md={2} className="g-4">
          {GUIDE_ARTICLES.map((article) => (
            <Col key={article.id}>
              <Card className="h-100 shadow-sm border-0">
                <Card.Body>
                  <Card.Title as="h2" className="h5">
                    <Link
                      to={getGuideSlug(article, lang)}
                      className="text-decoration-none stretched-link"
                    >
                      {t(`articles.${article.id}.h1`)}
                    </Link>
                  </Card.Title>
                  <Card.Text className="text-secondary small">
                    {t(`articles.${article.id}.meta.description`)}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

export default GuidesIndexPage;
